import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// Get Cameras +
export const getCams = createAsyncThunk(
  "video/getCams",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/cameras/`);
      console.log("getCams", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Switch Camera +
export const switchCam = createAsyncThunk(
  "video/switchCam",
  async (camId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/cameras/reolink/${camId}/toggle`
      );
      console.log("switchCam", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create camera +
export const createCam = createAsyncThunk(
  "video/createCam",
  async (camData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/cameras/`,
        camData
      );
      console.log("createCam", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update camera +
export const updateCam = createAsyncThunk(
  "video/updateCam",
  async (camData, thunkAPI) => {
    try {
      const { camId, ...data } = camData;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/cameras/${camId}/`,
        data
      );
      console.log("updateCam", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete camera +
export const deleteCam = createAsyncThunk(
  "video/deleteCam",
  async (camId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/cameras/${camId}/`
      );
      console.log("deleteCam", response.data);

      return { camId, ...response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
